import { subCategoryIdList } from '@/api/global';
import {
  getMoreViolations,
  onClickPay,
  payType,
  ServiceSubCategory,
  serviceType,
} from '@/commonTypes';
import React from 'react';

import ServiceResult from './ServiceResult';
import ServiceResultViolation from './ServiceResultViolation';
import AiInsight from '../AiInsight';

export default function ServiceDetails({
  data,
  onClickPay,
  serviceKey,
  violationCount,
  getMoreViolations,
  subCategoryInfo,
  lastHistoryInfo,
  callBackHistory,
  imagesService,
  loadingViolations = false,
}: {
  data?: ServiceSubCategory;
  onClickPay?: onClickPay;
  serviceKey?: string;
  violationCount?: string | number;
  getMoreViolations?: getMoreViolations;
  subCategoryInfo?: ServiceSubCategory;
  lastHistoryInfo?: any;
  callBackHistory?: any;
  imagesService?: ServiceSubCategory;
  loadingViolations?: boolean;
}) {
  console.log('dddddddddd', serviceKey);
  return (
    <div>
      {subCategoryInfo?.key == subCategoryIdList.vehicle_fines ? (
        <ServiceResultViolation
          data={data}
          onClickPay={onClickPay}
          violationCount={violationCount}
          getMoreViolations={getMoreViolations}
          subCategoryInfo={subCategoryInfo}
          lastHistoryInfo={lastHistoryInfo}
          callBackHistory={callBackHistory}
          imagesService={imagesService}
          loadingViolations={loadingViolations}
        />
      ) : (
        <ServiceResult
          data={data}
          type={serviceKey}
          onClickPay={onClickPay}
          callBackHistory={callBackHistory}
          subCategoryInfo={subCategoryInfo}
        />
      )}
      {/* <AiInsight
        title="تحلیل هوش مصنوعی کارا"
        description="۲ مورد از ۳ خلافی شما مربوط به سرعت غیرمجاز در آزادراه است. با رعایت سرعت مجاز می‌توانید تا ۴۵٪ از جریمه‌های آینده جلوگیری کنید. پرداخت یکجا همین حالا ۱۰٪ تخفیف دارد."
      /> */}
    </div>
  );
}
